//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XHeader from "vux/src/components/x-header/index";
export default {
  name: 'OnCheck',
  components: {XHeader},
  data () {
    return {
      mobile: '',
      termId: ''
    }
  },
  mounted () {
    this.mobile = sessionStorage.getItem('mobile')
    this.termId = sessionStorage.getItem('termId')
    // 安全校验，不允许未登陆的账号进入所有审核页面
    if (sessionStorage.getItem('mobile') === null) {
      this.$router.push({path: '/FindDetail'})
    }
  },
  methods: {
    //时间问候语
    getTimeState: function () {
      //获取当前时间
      let timeNow = new Date();
      //  获取当前消失
      let hours = timeNow.getHours();
      //  设置默认字
      let state = '';
      if (hours >= 0 && hours <= 10) {
        state = '同学上午好！'
      } else if (hours >10 && hours <= 14) {
        state = '同学中午好！'
      } else if (hours >14 && hours <= 18) {
        state = '同学下午好！'
      } else if (hours >18 && hours <= 24) {
        state = '同学晚上好！'
      }
      return state
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/OnCheck.vue